import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '@core/service/base.service';

@Injectable({
  providedIn: 'root'
})
export class CompactMatService extends BaseService{
  private url = "api/compact-mat";

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(){
    return this.url;
  }

}
